import { FC, PropsWithChildren } from "react";
import { ITransaction } from "../../model/types";
import classes from './transactionItem.module.scss'
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { TransactionMetaPopover } from "../../../../shared/ui/transactionMeta/TransactionMetaPopover";

interface IProps {
    transaction: ITransaction;
    showActions?: boolean;
}

export const TransactionItem: FC<IProps & PropsWithChildren> = ({transaction, showActions, children}) => {

    return (
        <tr 
            className={classes.item}
        >
            <td>
                {formatUtcToMsk(transaction.created_at)} (мск)
            </td>  
            <td>
                {transaction.amount}
            </td>
            <td>
                {transaction.is_confirmed ? <>&#9989;</> : <>&#10060;</>}
            </td>
            <td>
                {transaction.is_manual ? <>&#9989;</> : <>&#10060;</>}
            </td>
            <td>
                <TransactionMetaPopover meta={transaction.meta} />
            </td>
            {showActions && <td className={classes.actions}>{children}</td>}
        </tr>
    )
}
